import { AsYouType, parsePhoneNumberFromString, parsePhoneNumber } from 'libphonenumber-js/min';
import metadataRaw from 'libphonenumber-js/metadata.min.json';
import { getCountries } from './country';
const phoneMetadata = metadataRaw;
/**
 * E.164 dial codes by ISO 3166-1 alpha-2 code. Exhaustive over `CountryCode` —
 * TypeScript flags drift if a country is added to `COUNTRY_CODES` without a dial code.
 */
const DIAL_CODES = {
    AD: '376',
    AE: '971',
    AF: '93',
    AG: '1',
    AI: '1',
    AL: '355',
    AM: '374',
    AO: '244',
    AR: '54',
    AS: '1',
    AT: '43',
    AU: '61',
    AW: '297',
    AX: '358',
    AZ: '994',
    BA: '387',
    BB: '1',
    BD: '880',
    BE: '32',
    BF: '226',
    BG: '359',
    BH: '973',
    BI: '257',
    BJ: '229',
    BL: '590',
    BM: '1',
    BN: '673',
    BO: '591',
    BQ: '599',
    BR: '55',
    BS: '1',
    BT: '975',
    BW: '267',
    BY: '375',
    BZ: '501',
    CA: '1',
    CC: '61',
    CD: '243',
    CF: '236',
    CG: '242',
    CH: '41',
    CI: '225',
    CK: '682',
    CL: '56',
    CM: '237',
    CN: '86',
    CO: '57',
    CR: '506',
    CU: '53',
    CV: '238',
    CW: '599',
    CX: '61',
    CY: '357',
    CZ: '420',
    DE: '49',
    DJ: '253',
    DK: '45',
    DM: '1',
    DO: '1',
    DZ: '213',
    EC: '593',
    EE: '372',
    EG: '20',
    EH: '212',
    ER: '291',
    ES: '34',
    ET: '251',
    FI: '358',
    FJ: '679',
    FK: '500',
    FM: '691',
    FO: '298',
    FR: '33',
    GA: '241',
    GB: '44',
    GD: '1',
    GE: '995',
    GF: '594',
    GG: '44',
    GH: '233',
    GI: '350',
    GL: '299',
    GM: '220',
    GN: '224',
    GP: '590',
    GQ: '240',
    GR: '30',
    GT: '502',
    GU: '1',
    GW: '245',
    GY: '592',
    HK: '852',
    HN: '504',
    HR: '385',
    HT: '509',
    HU: '36',
    ID: '62',
    IE: '353',
    IL: '972',
    IM: '44',
    IN: '91',
    IO: '246',
    IQ: '964',
    IR: '98',
    IS: '354',
    IT: '39',
    JE: '44',
    JM: '1',
    JO: '962',
    JP: '81',
    KE: '254',
    KG: '996',
    KH: '855',
    KI: '686',
    KM: '269',
    KN: '1',
    KP: '850',
    KR: '82',
    KW: '965',
    KY: '1',
    KZ: '7',
    LA: '856',
    LB: '961',
    LC: '1',
    LI: '423',
    LK: '94',
    LR: '231',
    LS: '266',
    LT: '370',
    LU: '352',
    LV: '371',
    LY: '218',
    MA: '212',
    MC: '377',
    MD: '373',
    ME: '382',
    MF: '590',
    MG: '261',
    MH: '692',
    MK: '389',
    ML: '223',
    MM: '95',
    MN: '976',
    MO: '853',
    MP: '1',
    MQ: '596',
    MR: '222',
    MS: '1',
    MT: '356',
    MU: '230',
    MV: '960',
    MW: '265',
    MX: '52',
    MY: '60',
    MZ: '258',
    NA: '264',
    NC: '687',
    NE: '227',
    NF: '672',
    NG: '234',
    NI: '505',
    NL: '31',
    NO: '47',
    NP: '977',
    NR: '674',
    NU: '683',
    NZ: '64',
    OM: '968',
    PA: '507',
    PE: '51',
    PF: '689',
    PG: '675',
    PH: '63',
    PK: '92',
    PL: '48',
    PM: '508',
    PR: '1',
    PS: '970',
    PT: '351',
    PW: '680',
    PY: '595',
    QA: '974',
    RE: '262',
    RO: '40',
    RS: '381',
    RU: '7',
    RW: '250',
    SA: '966',
    SB: '677',
    SC: '248',
    SD: '249',
    SE: '46',
    SG: '65',
    SH: '290',
    SI: '386',
    SJ: '47',
    SK: '421',
    SL: '232',
    SM: '378',
    SN: '221',
    SO: '252',
    SR: '597',
    SS: '211',
    ST: '239',
    SV: '503',
    SX: '1',
    SY: '963',
    SZ: '268',
    TC: '1',
    TD: '235',
    TG: '228',
    TH: '66',
    TJ: '992',
    TK: '690',
    TL: '670',
    TM: '993',
    TN: '216',
    TO: '676',
    TR: '90',
    TT: '1',
    TV: '688',
    TW: '886',
    TZ: '255',
    UA: '380',
    UG: '256',
    US: '1',
    UY: '598',
    UZ: '998',
    VA: '39',
    VC: '1',
    VE: '58',
    VG: '1',
    VI: '1',
    VN: '84',
    VU: '678',
    WF: '681',
    WS: '685',
    XK: '383',
    YE: '967',
    YT: '262',
    ZA: '27',
    ZM: '260',
    ZW: '263'
};
export { isValidPhoneNumber } from 'libphonenumber-js/min';
/**
 * Formats a phone number string as it is being entered by the user.
 * Applies the national number pattern for the given country, including
 * trunk prefix, separators, and grouping (e.g. '054921' → '054-921' for IL).
 * Safe to call with partial/incomplete input.
 */
export function formatPhoneAsYouType(input, countryCode) {
    return new AsYouType(countryCode).input(input);
}
/**
 * Returns the national display format for a stored phone value, including the
 * national trunk prefix (e.g. '+442071234567' → '020 7123 4567' for GB).
 * Returns null if the value cannot be parsed (e.g. partial input).
 */
export function formatNationalPhoneNumber(value, countryCode) {
    try {
        const phone = parsePhoneNumber(value, countryCode);
        return phone.isValid() ? phone.formatNational() : null;
    }
    catch {
        return null;
    }
}
/**
 * Returns the maximum number of national significant digits for the given country.
 * Used to cap phone input fields. Falls back to 15 (international max) for
 * unknown country codes.
 */
export function getMaxNationalPhoneDigits(countryCode) {
    const entry = phoneMetadata.countries[countryCode];
    if (!entry) {
        return 15;
    }
    const lengths = entry[3];
    return Array.isArray(lengths) && lengths.length ? Math.max(...lengths) : 15;
}
/**
 * Parses a legacy phone string (with or without '+') into structured E.164 components.
 *
 * HoneyBook's DB stores numbers without a '+' prefix (legacy format). New numbers saved
 * via HBPhoneInput will have '+' (E.164). This function handles both during the transition.
 * Once all stored numbers are migrated to E.164, strategies 2–5 below become dead code
 * and this can be simplified to a direct `parsePhoneNumberFromString` call.
 *
 * A plain `parsePhoneNumberFromString(raw, hint?)` call is not sufficient on its own:
 * it doesn't strip IDD '00' prefixes, has no NANP-priority heuristic for 10-digit inputs
 * (causing CC collisions like 868... → China instead of Trinidad), and is single-shot with
 * no fallback chain.
 *
 * Pass `countryCodeHint` (company country) for numbers stored without a prefix — it is
 * the tiebreaker for ambiguous 10-digit inputs. For numbers that already start with '+'
 * the hint is ignored.
 *
 * Returns `null` when the input cannot be resolved to a valid number. Callers should
 * treat null as "ask the user to confirm their country and re-enter."
 */
export function parseLegacyPhoneNumber(raw, countryCodeHint) {
    const cleaned = raw.trim();
    const digits = cleaned.replace(/\D/g, '');
    if (!digits) {
        return null;
    }
    // Strategy 1: E.164 — already has '+', parse directly. Hint is irrelevant.
    if (cleaned.startsWith('+')) {
        return toParsedPhone(parsePhoneNumberFromString(cleaned));
    }
    // Strategy 2: IDD prefix (European outbound dialing: 001..., 0044..., etc.)
    // The library does NOT strip leading '00' automatically.
    if (digits.startsWith('00')) {
        const result = toParsedPhone(parsePhoneNumberFromString('+' + digits.slice(2)));
        if (result) {
            return result;
        }
    }
    // Strategy 3: 10-digit NANP priority.
    // For a US-centric DB, a bare 10-digit number is almost certainly NANP.
    // '+'-prepend is tried AFTER this to avoid CC collisions:
    //   '8685551234' via +prepend → CN (China +86) — almost certainly wrong
    //   '8685551234' via US hint  → TT (Trinidad +1868) — far more likely
    if (digits.length === 10) {
        const hint = countryCodeHint ?? 'US';
        const result = toParsedPhone(parsePhoneNumberFromString(digits, hint));
        if (result) {
            return result;
        }
    }
    // Strategy 4: treat all digits as CC-prefixed — prepend '+'.
    // Handles: '14155551234' → US, '441614960000' → GB, '972521234567' → IL
    const result = toParsedPhone(parsePhoneNumberFromString('+' + digits));
    if (result) {
        return result;
    }
    // Strategy 5: explicit country hint as last resort.
    // Reaches here for domestic formats with a leading 0 or short digit counts.
    if (countryCodeHint) {
        const hinted = toParsedPhone(parsePhoneNumberFromString(digits, countryCodeHint));
        if (hinted) {
            return hinted;
        }
    }
    return null;
}
function toParsedPhone(phone) {
    if (!phone || !phone.country || !phone.isValid()) {
        return null;
    }
    return {
        international: phone.number,
        countryCode: phone.country,
        nationalNumber: phone.nationalNumber,
        dialCode: `+${DIAL_CODES[phone.country]}`
    };
}
function parseToNational(raw, countryHint) {
    const parsed = parseLegacyPhoneNumber(raw, countryHint);
    if (!parsed) {
        return null;
    }
    const national = formatNationalPhoneNumber(parsed.international, parsed.countryCode);
    if (!national) {
        return null;
    }
    return { parsed, national };
}
/**
 * Formats a stored phone string for display: parses the legacy/E.164 value, then
 * returns `"<dialCode> <national>"` (e.g. `"+1 (415) 555-1234"` for US).
 * Passes the original string through unchanged if it cannot be parsed or formatted.
 * Pass `countryHint` (company country) to improve parsing accuracy for numbers
 * stored without a country prefix.
 */
export function formatPhone(phone, countryHint) {
    if (!phone) {
        return phone;
    }
    const result = parseToNational(phone, countryHint);
    if (!result) {
        return phone;
    }
    return `${result.parsed.dialCode} ${result.national}`;
}
const KEEP_LAST = 4;
const MASK_CHAR = '*';
/**
 * Returns a masked national-format phone string where every digit except the last 4
 * is replaced with `*`, preserving the separators (spaces, dashes, parentheses) from
 * the country's national format. Country code / dial code is *not* included in the
 * output.
 *
 * Examples:
 * ```
 *   '+14155551234'  → '(***) ***-1234'   // US
 *   '+442071234567' → '*** **** 4567'    // GB
 *   '+972501234567' → '***-***-4567'     // IL
 * ```
 *
 * Falls back when parsing or national formatting fails:
 * - Strips non-digits from the input; if at least one digit remains and there are
 *   more than 4, returns `***-<last 4 digits>` (e.g. `***-1234`).
 * - If there are 4 digits or fewer, returns those digits as-is.
 * - Empty / all-non-digit input → `''`.
 *
 * Country code prefix is intentionally omitted — callers that want a flag/dial-code
 * decoration should add it alongside (e.g. via `HBPhoneInput`'s country selector).
 */
export function maskPhoneNationally(raw) {
    if (!raw) {
        return '';
    }
    const result = parseToNational(raw);
    if (result) {
        return maskDigitsExceptLast(result.national);
    }
    const digits = raw.replace(/\D/g, '');
    if (!digits) {
        return '';
    }
    if (digits.length <= KEEP_LAST) {
        return digits;
    }
    return `${MASK_CHAR.repeat(3)}-${digits.slice(-KEEP_LAST)}`;
}
function maskDigitsExceptLast(formatted) {
    const totalDigits = formatted.replace(/\D/g, '').length;
    if (totalDigits <= KEEP_LAST) {
        return formatted;
    }
    const digitsToMask = totalDigits - KEEP_LAST;
    let seen = 0;
    return formatted.replace(/\d/g, digit => seen++ < digitsToMask ? MASK_CHAR : digit);
}
/**
 * Returns the full list of phone countries — locale-aware names + flag emoji from
 * `getCountries`, plus E.164 dial codes. Inherits the unresolved-name filtering from
 * `getCountries`, so consumers never see entries with placeholder names.
 */
export const getPhoneCountries = (locale) => getCountries(locale).map(country => ({
    ...country,
    dialCode: `+${DIAL_CODES[country.code]}`
}));
//# sourceMappingURL=phone.js.map